module.exports = __webpack_public_path__ + "img/cardMultiColor-Back.89150b6c.png";